/* tslint:disable */
type SimbolosEnum =
  'MAIOR' |
  'MENOR' |
  'ATE';
module SimbolosEnum {
  export const MAIOR: SimbolosEnum = 'MAIOR';
  export const MENOR: SimbolosEnum = 'MENOR';
  export const ATE: SimbolosEnum = 'ATE';
  export function values(): SimbolosEnum[] {
    return [
      MAIOR,
      MENOR,
      ATE
    ];
  }
}

export { SimbolosEnum }